// Helpers for the pipeline end time and start window rules enforced by the server.
// Every pipeline time is Africa/Lagos (WAT, UTC+1), whatever the browser's time zone.

const PIPELINE_TIME_ZONE = "Africa/Lagos";
const PIPELINE_ENDS_AT_KEY = "pipeline-ends-at";

const toDate = (iso) => {
  if (!iso) return null;
  const date = new Date(iso);
  return isNaN(date.getTime()) ? null : date;
};

/* "11:59 PM, 25 Oct (WAT)" */
export const formatPipelineTime = (iso, { withDate = true } = {}) => {
  const date = toDate(iso);
  if (!date) return "";
  const time = date.toLocaleTimeString("en-GB", {
    timeZone: PIPELINE_TIME_ZONE,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).toUpperCase();
  if (!withDate) return `${time} (WAT)`;
  const day = date.toLocaleDateString("en-GB", {
    timeZone: PIPELINE_TIME_ZONE,
    day: "numeric",
    month: "short",
  });
  return `${time}, ${day} (WAT)`;
};

export const hasPassed = (iso) => {
  const date = toDate(iso);
  return !!date && Date.now() >= date.getTime();
};

/* Milliseconds timestamp of the pipeline end, or null when the rule is off. */
export const getPipelineEndsAt = () => {
  const stored = toDate(sessionStorage.getItem(PIPELINE_ENDS_AT_KEY));
  return stored ? stored.getTime() : null;
};

export const setPipelineEndsAt = (iso) => {
  if (toDate(iso)) sessionStorage.setItem(PIPELINE_ENDS_AT_KEY, iso);
  else sessionStorage.removeItem(PIPELINE_ENDS_AT_KEY);
};

/* initiate-questions refused a fresh start: too close to (or past) the pipeline end. */
export const isStartWindowClosedError = (error) =>
  error?.response?.status === 403 &&
  error?.response?.data?.code === "START_WINDOW_CLOSED";

/* save-answers after the attempt was closed by the server (pipeline ended). */
export const isAttemptClosedError = (error) =>
  error?.response?.status === 400 &&
  error?.response?.data?.message === "User has completed this exam";

/* submit-assessment for an attempt that is already completed: treat as a successful submit. */
export const isAlreadyCompletedError = (error) =>
  error?.response?.status === 400 &&
  error?.response?.data?.code === "ALREADY_COMPLETED";

/* Wraps a submit-assessment call so an ALREADY_COMPLETED answer resolves like a successful submit. */
export const treatAlreadyCompletedAsSubmitted = (submit) => (variables) =>
  submit(variables).catch((error) => {
    if (isAlreadyCompletedError(error)) return error.response.data;
    throw error;
  });
